import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance, scrollTop } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  BeforeYouStart,
  BikeTheft,
  CodeMatch,
  CycleHangarIdDetails,
  CycleHangarSecured,
  IssueLocation,
  KeyTurn,
  LockCodeDetials,
  SelectCycleHangarIssue,
  UploadPhotoPage,
  Vandalism,
  VandalismTellUsMore,
  Cleaning,
  Abandoned,
  AbandonedProvideDescription,
  TellUsMore,
  EmailConfirmationReport,
  YourDetails,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';
import { Confirmation } from './components/pages/confirmation/Confirmation';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  const location = useLocation();

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route path={RoutesList.LANDING_PAGE} element={<BeforeYouStart />} />
          <Route path={RoutesList.HOME} element={<BeforeYouStart />} />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhotoPage />} />
          <Route path={RoutesList.DETAILS} element={<CycleHangarIdDetails />} />
          <Route path={RoutesList.ISSUE_LOCATION} element={<IssueLocation />} />
          <Route
            path={RoutesList.ISSUE_SELECTION}
            element={<SelectCycleHangarIssue />}
          />
          <Route
            path={RoutesList.CYCLE_HANGAR_SECURE}
            element={<CycleHangarSecured />}
          />
          <Route path={RoutesList.CODE_MATCH} element={<CodeMatch />} />
          <Route path={RoutesList.KEY_TURN} element={<KeyTurn />} />
          <Route
            path={RoutesList.LOCK_CODE_DETAILS}
            element={<LockCodeDetials />}
          />
          <Route path={RoutesList.BIKE_THEFT} element={<BikeTheft />} />
          <Route
            path={RoutesList.DAMAGED_OR_VANDALISED}
            element={<Vandalism />}
          />
          <Route
            path={RoutesList.DAMAGED_OR_VANDALISED_TELL_US_MORE}
            element={<VandalismTellUsMore />}
          />
          <Route path={RoutesList.TELL_US_MORE} element={<TellUsMore />} />
          <Route path={RoutesList.CLEANING} element={<Cleaning />} />
          <Route
            path={RoutesList.ABANDONED_OR_UNAUTHORISED}
            element={<Abandoned />}
          />
          <Route
            path={RoutesList.ABANDONED_OR_UNAUTHORISED_DESCRIBE}
            element={<AbandonedProvideDescription />}
          />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<EmailConfirmationReport />}
          />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />

          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
